import { CommonModule } from "@angular/common";
import { Component, forwardRef, Input, OnInit, signal } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-rating-star",
  templateUrl: "./rating-star.component.html",
  styleUrl: "./rating-star.component.scss",
  imports: [CommonModule, ReactiveFormsModule, NgbTooltipModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingStarComponent),
      multi: true,
    },
  ],
})
export class RatingStarComponent implements OnInit, ControlValueAccessor {
  @Input()
  rating = 0;

  @Input() modeForm = false;
  @Input() iconSize = "fs-5";

  form = new FormControl();
  isSelect = signal<boolean>(false);
  starArray: number[] = Array(5).fill(0);

  onChange = (_: number) => {};
  onTouched = () => {};

  ngOnInit(): void {
    this.writeValue(this.rating);
  }

  writeValue(value: number): void {
    this.rating = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  selectStar(score: number) {
    if (!this.modeForm) {
      return;
    }
    if (score === this.rating) {
      this.rating = 0;
    } else {
      this.rating = score;
    }
    this.onChange(this.rating); // 🔥 สำคัญมาก
    this.onTouched();
  }
}
